import {CommentIcon} from '@primer/octicons-react'
import {useMemo} from 'react'
import {extractReasoningPreview} from './extract-reasoning-preview'
import {Tool, ToolPrimaryContent} from './tool/ToolPrimitives'
import {ActivityTicker} from './ActivityTicker'
import styles from './ThinkingBlock.module.css'

export type ThinkingBlockProps = {
  reasoningText: string
  isInGroup?: boolean
  isStreaming?: boolean
  defaultExpanded?: boolean
}

export function ThinkingBlock({reasoningText, isInGroup, isStreaming, defaultExpanded = false}: ThinkingBlockProps) {
  const preview = useMemo(
    () => (isStreaming === true ? extractReasoningPreview(reasoningText) : null),
    [isStreaming, reasoningText],
  )

  return (
    <Tool
      title="Thinking"
      isError={false}
      collapsible
      isPending={isStreaming === true}
      isOpenOverride={defaultExpanded || isStreaming === undefined}
      bordered={false}
      isInGroup={isInGroup}
      showTitleSuffixWhenCollapsedOnly
      toolHeaderProps={{
        leadingVisual: <CommentIcon size={16} aria-hidden="true" />,
        titleSuffix: preview ? (
          <span className={styles.previewContainer} aria-hidden="true">
            <span className={styles.previewSeparator}>·</span>
            <ActivityTicker text={preview} className={styles.preview} />
          </span>
        ) : undefined,
      }}
    >
      <div className={styles.thinkingContent}>
        <ToolPrimaryContent language="markdown" markdown={reasoningText} />
      </div>
    </Tool>
  )
}
